import { render, staticRenderFns } from "./EProtocoloTable.vue?vue&type=template&id=c97c77dc&scoped=true&"
import script from "./EProtocoloTable.vue?vue&type=script&lang=js&"
export * from "./EProtocoloTable.vue?vue&type=script&lang=js&"
import style0 from "./EProtocoloTable.vue?vue&type=style&index=0&id=c97c77dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97c77dc",
  null
  
)

export default component.exports